<template>
    <div>
        
        <el-card class="box-card" :style="'height:'+bodyHeight+'px'">

                <div slot="header" class="clearfix">
                   <el-input
                        size="small"
                        style="width:350px"
                        placeholder="用户手机号/任务编号/订单编号/买手账号/店铺名称"
                        v-model="queryModel.queryTxt"
                        @keydown.enter.native="query"
                        clearable>
                        </el-input>
                        <el-date-picker
                        style="margin-left:20px;width:250px"
                        size="small"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select size="small" style="margin-left:20px;width:100px"  filterable   v-model="queryModel.managerId" clearable placeholder="审核人">
                            <el-option v-for="v in managerList" :key="v.Id" :label="v.RealName" :value="v.Id"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:20px;width:100px"  filterable   v-model="queryModel.status" clearable placeholder="状态">
                            <el-option   label="待好评" :value="1"> </el-option>
                            <el-option   label="待审核" :value="2"> </el-option>
                            <el-option   label="已完成" :value="3"> </el-option>
                        </el-select>
                        <el-checkbox style="margin-left:20px" v-model="queryModel.isTimeOut">已超时</el-checkbox>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:10px;" @click="queryAction" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                   <el-pagination style="float:right;margin-top:-2px"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryModel.pIndex"
                    :page-sizes="[10, 20, 40, 60]"
                    :page-size="queryModel.pSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>

                <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                        width="180px"
                            label="工单编号">
                            <template slot-scope="scope">
                                <el-link @click="showDetail(scope.row)" target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="商品名称">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" placement="right">
                                    <div slot="content" style="width:200px;line-height:18px">{{scope.row.Title}}</div>
                                    <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Title}}</div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="OrderCode"
                                label="买手提交单号">
                        </el-table-column>
                        <el-table-column
                                prop="Spec"
                                label="规格">
                        </el-table-column> 
                        <el-table-column
                                width="120px"
                                label="买手垫付本金">
                                <template slot-scope="scope">
                                    <el-link   type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="AliTrademanager"
                                label="买手账号">
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="好评佣金">
                            <template slot-scope="scope">
                                <el-link type="danger">￥{{scope.row.PraiseCost.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="Phone"
                                label="手机">
                        </el-table-column> 
                        <el-table-column
                        width="160"
                                prop="OrderTime"
                                label="接单时间">
                        </el-table-column>   

                        <el-table-column
                            label="子链接">
                            <template v-if="scope.row.ChildNum>0" slot-scope="scope">
                                <el-link target="_blank" @click="orderGetPraiseChild(scope.row)"  type="primary">
                                    <el-tag  effect="dark" size="small" type="success">{{scope.row.ChildNum}}</el-tag>
                                </el-link>
                            </template>
                        </el-table-column>  

                        <el-table-column
                        label="状态">
                            <template  slot-scope="scope">
                                <el-tag effect="dark"  type="info"  v-if="scope.row.PraiseStatus==0" size="mini" >已取消</el-tag>
                                <el-tag effect="dark"  v-else-if="scope.row.PraiseStatus==1" size="mini" >待好评</el-tag>
                                <el-tag effect="dark"  type="warning" v-else-if="scope.row.PraiseStatus==2" size="mini" >待审核</el-tag>
                                <el-tag effect="dark"  type="success" v-else size="mini" >已完成</el-tag>
                                <el-tag v-if="scope.row.IsTimeOut" effect="dark"  type="danger" style="margin-left:5px"  size="mini" >已超时</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column 
                        width="165"
                            label="操作" >
                                <template slot-scope="scope">
                                    <el-tooltip  class="item" effect="dark" content="查看好评需求" placement="bottom">
                                        <el-button  size="mini"  @click="viewImg(scope.row)" icon="el-icon-folder" circle></el-button>
                                    </el-tooltip>
                                    <!-- <el-tooltip  v-if="scope.row.ReviewImg" class="item" effect="dark" content="查看刷手上传的截图" placement="bottom">
                                        <el-button  size="mini"  @click="seeImgs(scope.row)" icon="el-icon-view" circle></el-button>
                                    </el-tooltip> -->
                                    <el-tooltip v-if="scope.row.IsTimeOut" class="item" effect="dark" content="发送消息给该刷手" placement="bottom">
                                        <el-button  size="mini" type="primary" @click="sendMsg(scope.row)" icon="el-icon-chat-round" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip v-if="scope.row.PraiseStatus==2" class="item" effect="dark" content="审核通过" placement="bottom">
                                        <el-button  size="mini" type="success" @click="pass(scope.row)" icon="el-icon-check" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip v-if="scope.row.PraiseStatus==2" class="item" effect="dark" content="审核不通过" placement="bottom">
                                        <el-button  size="mini" type="danger" @click="over(scope.row)" icon="el-icon-close" circle></el-button>
                                    </el-tooltip>
                                 
                                    <el-tooltip v-if="scope.row.PraiseStatus==1" class="item" effect="dark" content="取消好评任务" placement="bottom">
                                        <el-button  size="mini" type="danger" @click="canel(scope.row)" icon="el-icon-delete" circle></el-button>
                                    </el-tooltip> 
                                </template>
                        </el-table-column>
                    </el-table>
             
        </el-card>

        
        <el-drawer
        :title="'子链接'"
        size="600"
        
        :visible.sync="child"
        direction="btt">
            <div style="padding-left:20px;padding-right:20px">
                <el-table
                :height="500"
                :data="childs"
                style="width: 100%">
                    <el-table-column width="300px"
                        label="商品标题">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="right">
                                <div slot="content" style="width:200px;line-height:18px">{{scope.row.Title}}</div>
                                <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Title}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column width="100px"
                        label="图片链接">
                        <template slot-scope="scope">
                            <el-link target="_blank"  @click="showImg(scope.row)" type="primary">点击查看</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column width="200px"
                        label="购买规格">
                        <template slot-scope="scope">
                              <el-link @click="setKey(scope.row,1)" type="info">{{scope.row.Spec}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column width="1000px"
                        label="好评内容">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="right">
                                <div slot="content" style="width:500px;line-height:18px">{{scope.row.PositiveContent}}</div>
                                <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.PositiveContent}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column width="200px"
                        label="图片及视频">
                        <template slot-scope="scope">
                        <el-link v-if="scope.row.PositiveContent" @click="viewImg(scope.row)" type="primary">查看资源</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <b>刷手截图：</b>
            <div v-if="PraiseReviewImg" style="margin-top:20px;">
                <el-image 
                v-for="(v,i) in PraiseReviewImg" :key="i"
                    style="width: 100px; height: 100px;margin-left:5px"
                    :src="v" 
                    :preview-src-list="PraiseReviewImg">
                </el-image>
            </div>
        </el-drawer>

        <el-image-viewer 
                style="z-index:999999"
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="imgs" />
                <el-dialog
                title="好评内容"
                :visible.sync="videoVisible"
                width="1000px"
                :before-close="handleClose">
                    <div>
                        <b>
                            {{viewRow.PositiveContent}}
                        </b>
                    </div>
                    <div v-if="this.url" style="margin-top:20px;">
                        <el-image 
                            v-for="(v,i) in url" :key="i"
                                style="width: 100px; height: 100px;margin-left:5px"
                                :src="v" 
                                :preview-src-list="url">
                            </el-image>
                    </div>
                    <div v-if="viewRow.Video" style="margin-top:20px;">
                        <video src="" id="video1" width="100%" height="400px"  controls>
                            您的浏览器不支持 video 标签。
                        </video>
                    </div>
                    <div v-if="viewRow.PraiseReviewImgList" style="margin-top:10px">
                        <b>刷手截图：</b>
                        <br/>
                         <el-image 
                                style="max-width:280px"
                                :src="viewRow.ReviewImg" 
                                :preview-src-list="[viewRow.ReviewImg]">
                        </el-image>
                        <div v-if="viewRow.PraiseReviewImgList" style="margin-top:20px;">
                            <el-image 
                                v-for="(v,i) in viewRow.PraiseReviewImgList" :key="i"
                                style="max-width:280px"
                                :src="v" 
                                :preview-src-list="viewRow.PraiseReviewImgList">
                            </el-image>
                        </div>
                    </div>
                </el-dialog>
    </div>
</template>
<script>

import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import {orderPraiseOrderCanle, managerGetSel,orderGetNeedPraiseOrder,swipeSendMsg,orderPraiseOrderPass,orderPraiseOrderFail,orderGetPraiseChild} from '@/request.js'
export default {
  name: 'App',
    props:{
        member:{
        type:Object,
        required: true
        }
    },
  components: {
      ElImageViewer
  },
  data() {
    return {
        showViewer:false,
        bodyHeight:0,
        total:0,
        child:false,
        childs:[],
        queryModel:{
            queryTxt:"",
            status:"",
            pIndex:1,
            pSize:10,
            createTimes:[],
            managerId:"",
            isTimeOut:false,
        },
        tableData:[],
        imgs:[],
        setRow:{},
        isLoading:false,
        managerList:[],
        viewRow:{},
        url:[],
        videoVisible:false,
        PraiseReviewImg:[],
    };
  },
  watch:{
  },
  created() {
        this.bodyHeight=document.documentElement.clientHeight-129;
  },
  mounted() {
      managerGetSel({},(res)=>{
            this.managerList=res.Result;
        });
       let taskcode = this.$route.query.taskcode;
       let queryTxt = this.$route.query.queryTxt;
       if(taskcode){
           this.queryModel.queryTxt=taskcode;
       }
       if(queryTxt){
           this.queryModel.queryTxt=queryTxt;
       }
      this.query();
  },
   methods:{
       canel(scope){
            this.$confirm('确认取消这个好评任务吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                orderPraiseOrderCanle({
                    orderId:scope.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        scope.PraiseStatus=0;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
 
            });
       },
       handleClose(done){
            if(document.getElementById("video1")){
                document.getElementById("video1").src="";
                document.getElementById("video1").load();
            }
            done();
        },
        viewImg(scope){
            this.url=JSON.parse(scope.ResourcesImg);
            this.viewRow=scope;
            this.videoVisible=true;
            setTimeout(() => {
                document.getElementById("video1").src=scope.Video;
                document.getElementById("video1").load();
            }, 100);
        },
       pass(scope){
            this.$confirm('确认审核通过吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                orderPraiseOrderPass({
                    orderId:scope.Id,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.PraiseStatus=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
       },
       over(scope){
            this.$prompt('请输入不通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入不通过原因'
            }).then(({ value }) => {
                orderPraiseOrderFail({
                    orderId:scope.Id,
                    remark:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.PraiseStatus=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
       },
        sendMsg(scope){
            this.$prompt('请填写您要发送的内容', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^.{10,100}$/,
            inputErrorMessage: '长度限制为10-100'
            }).then(({ value }) => {
                swipeSendMsg({message:value,swipeId:scope.SwipeId},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
       closeImg(){
            this.showViewer=false;
        },
       seeImgs(scope){
           this.imgs=[scope.ReviewImg];
           this.showViewer=true;
       },

       queryAction(){
           this.queryModel.pIndex=1;
           this.query();
       },
       query(){
           this.isLoading=true;
           orderGetNeedPraiseOrder({
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
                managerId:this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId),
                isTimeOut:this.queryModel.isTimeOut
           },(res)=>{
               this.tableData=res.Result;
               this.total=res.TotalCount;
               this.isLoading=false;
           })
       },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
        orderGetPraiseChild(v){
            this.PraiseReviewImg=JSON.parse(v.PraiseReviewImg);
            orderGetPraiseChild({detailId:v.DetailId},(res)=>{
                this.childs=res.Result;
                this.child=true;
            })
        },
        
   },
}
</script>
<style scoped>

</style>